import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const navLinks = [
  { href: '/about', label: 'About' },
  { href: '/services', label: 'Services' },
  { href: '/case-studies', label: 'Case Studies' },
  { href: '/why-imane', label: 'Why iMANE' },
  { href: '/careers', label: 'Careers' },
  { href: '/contact', label: 'Contact' },
  { href: '/contact', label: 'Privacy Policy' },
];

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Left — Logo + tagline + socials */}
          <div>
            <img
              src="/imane-logo.png"
              alt="iMANE"
              className="h-10 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed mt-3">
              Transform. Optimize. Accelerate.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.linkedin.com/company/imane-labs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-brand-orange transition-colors cursor-pointer"
                aria-label="iMANE LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://www.instagram.com/imane_labs/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-brand-orange transition-colors cursor-pointer"
                aria-label="iMANE Instagram"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Centre — Nav links */}
          <div>
            <h4 className="font-lexend font-semibold text-sm text-slate-300 uppercase tracking-wider mb-5">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href + link.label}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-brand-orange text-sm transition-colors"
                    data-testid={`footer-nav-${link.label.toLowerCase().replace(/ /g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right — Contact */}
          <div>
            <h4 className="font-lexend font-semibold text-sm text-slate-300 uppercase tracking-wider mb-5">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-brand-orange mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:info@imane.in"
                  className="text-slate-400 hover:text-brand-orange text-sm transition-colors"
                  data-testid="footer-email"
                >
                  info@imane.in
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-brand-orange mt-0.5 flex-shrink-0" />
                <a
                  href="tel:+919637625311"
                  className="text-slate-400 hover:text-brand-orange text-sm transition-colors"
                  data-testid="footer-phone"
                >
                  +91 96376 25311
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-brand-orange mt-0.5 flex-shrink-0" />
                <div className="space-y-3">
                  <div>
                    <p className="text-slate-300 text-xs font-semibold uppercase tracking-wider mb-1">Registered Office</p>
                    <span className="text-slate-400 text-sm leading-relaxed block">
                      Kalpataru Harmony, Wakad,<br />
                      Pune, Maharashtra 411057
                    </span>
                  </div>
                  <div>
                    <p className="text-slate-300 text-xs font-semibold uppercase tracking-wider mb-1">Pune</p>
                    <span className="text-slate-400 text-sm leading-relaxed block">
                      A102, Shree Residency,<br />
                      Near Laxmi Mata Mandir,<br />
                      Balewadi, Pune 411045
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
            <p>
              &copy; 2025 Mane Labs LLP. All rights reserved.
            </p>
            <p>
              Developed by{' '}
              <a
                href="https://buffetism.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-brand-orange transition-colors inline-flex items-center gap-1"
                data-testid="footer-buffetism"
              >
                BUFFETISM IT VENTURES
                <ExternalLink size={12} />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
